import { render } from "./AppProfileData.vue?vue&type=template&id=04dabd8d&scoped=true"
import script from "./AppProfileData.vue?vue&type=script&lang=js"
export * from "./AppProfileData.vue?vue&type=script&lang=js"

import "./AppProfileData.vue?vue&type=style&index=0&id=04dabd8d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dabd8d"]])

export default __exports__